<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;margin-bottom:20px;
}
.desc-title{
  font-size: 16px;text-indent: 0;margin-bottom:15px;font-weight: bold;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
.cons{
  display: none;
}
.process-img{
  text-align: center;
  /deep/ img{
    width:80%;
    margin: auto;
  }
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
  .cons{
    display: block!important;
  }
  .con{
    display: none!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-PCR克隆 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc">PCR克隆技术不依赖于载体的酶切位点，能够根据客户提供的模板及模板序列，设计扩增引物，将目的基因片段直接克隆至任何载体的指定位点，并测序验证。</p>
      </div>
      <!-- 产品优势 -->
      <div class="compose-type">
        <div class="container">
          <en-title title="产品优势" enTitle="Advantages"></en-title>
          <gene-advantages :menuTitle="bigTitle" :advantagesList="advantagesList" ></gene-advantages>
        </div>
      </div>
      <!-- 服务流程 -->
      <div class="container">
        <en-title title="服务流程" enTitle="Service Process"></en-title>
          <mobile-img class="process-img" url="images/gene_second/PCR_cloning/process" imgAlt="PCR克隆-服务流程"></mobile-img>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 应用领域 -->
      <div class="container">
        <en-title title="应用领域" enTitle="Application"></en-title>
        <p class="desc-title">1.DNA 重组</p>
        <p class="desc">在分子生物学研究中，可以通过PCR克隆技术在体外将不同来源的特异基因或DNA片段插入病毒、质粒或其他载体，构建重组DNA分子，再导入到受体细胞中进行扩增和繁殖，经过筛选，把含有目的基因的转化子细胞再扩增提取获得大量DNA。</p>
        <p class="desc-title mt50">2.基因定量检测</p>
        <p class="desc">PCR克隆技术可以定量监测标本中靶基因的拷贝数，将目的基因和一个单拷贝的参照基因置于同一个试管中进行PCR克隆。电泳分离后观察条带强度，或在引物5’端标记放射性核素，通过检测两条带放射性强度来检测基因拷贝数。</p>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
import MobileImg from '@/components/MobileImg'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
    MobileImg,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'PCR克隆',
      advantagesList:[
        {
          img:'gene_second/PCR_cloning/icon_1',
          title:'高准确率',
          text:'Sanger测序验证，100%准确',
        },
        {
          img:'gene_second/PCR_cloning/icon_2',
          title:'高交付率',
          text:'交付率>99.5%',
        },
        {
          img:'gene_second/PCR_cloning/icon_3',
          title:'多片段无缝连接',
          text:'不引入额外的序列',
        }
        
      ],
      tableColumn:[
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（工作日）',
          prop:'productionCycle',
        },
        {
          label:'载体',
          prop:'carrier',
        },
      ],
      tableData:[
        {
          geneLength:'< 3 kb',
          productionCycle:'7 - 10',
          carrier:'客户指定载体',
        },
        {
          geneLength:'3 kb - 5 kb',
          productionCycle:'10 - 12',
        },
        {
          geneLength:'5 kb - 7 kb',
          productionCycle:'12 - 15',
        },
        {
          geneLength:'> 7 kb',
          productionCycle:'需要评估',
        },

      ],
      products:'冻干质粒 DNA 一管 ( 高拷贝约4 μg/ 管，低拷贝1-4 μg/ 管 )\n含有重组质粒的穿刺菌一管',
      reports:'测序图谱 (.abl 文件 )\n目标序列 (.seq 文件 )\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   
      if (columnIndex === 2) {
        return {
          rowspan: row.carrier ? 4 : 0,
          colspan: row.carrier ? 1 : 0
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/PCR_cloning.vue